import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-navy-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="font-serif mb-4">
              <h2 className="text-2xl font-bold tracking-tight">
                <span className="text-white">Magic C</span>
                <span className="text-sage-400 ml-2">Plumbing</span>
              </h2>
              <p className="text-xs tracking-widest text-gray-400 uppercase mt-1">Premium Services</p>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-6">
              Premium plumbing and heating services with 15+ years of excellence. 
              Your trusted partner for luxury renovations and reliable solutions.
            </p>
            
            {/* Certifications */}
            <div className="space-y-3">
              <p className="text-xs font-semibold text-sage-400 uppercase tracking-wider">Accredited & Certified</p>
              <div className="flex flex-wrap gap-4 items-center">
                {/* Gas Safe Logo */}
                <div className="bg-white p-2 rounded">
                  <img 
                    src="https://www.gassaferegister.co.uk/media/1162/gsr-logo.png" 
                    alt="Gas Safe Register" 
                    className="h-10 w-auto"
                  />
                </div>
                {/* Additional Certifications */}
                <div className="flex flex-col space-y-1 text-xs text-gray-400">
                  <span>✓ City & Guilds Certified</span>
                  <span>✓ OFTEC Registered</span>
                  <span>✓ CIPHE Member</span>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-sage-300 transition-colors text-sm inline-flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Home</span>
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-sage-300 transition-colors text-sm inline-flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">About Us</span>
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-sage-300 transition-colors text-sm inline-flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Services</span>
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-300 hover:text-sage-300 transition-colors text-sm inline-flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Gallery</span>
                </Link>
              </li>
              <li>
                <Link to="/recruitment" className="text-gray-300 hover:text-sage-300 transition-colors text-sm inline-flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Recruitment</span>
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-sage-300 transition-colors text-sm inline-flex items-center group">
                  <span className="group-hover:translate-x-1 transition-transform">Contact</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white">Our Services</h3>
            <ul className="space-y-3 text-sm text-gray-300">
              <li className="hover:text-sage-300 transition-colors cursor-pointer">24/7 Emergency Plumbing</li>
              <li className="hover:text-sage-300 transition-colors cursor-pointer">Heating Installation & Design</li>
              <li className="hover:text-sage-300 transition-colors cursor-pointer">Luxury Bathroom Renovation</li>
              <li className="hover:text-sage-300 transition-colors cursor-pointer">Smart Plumbing Solutions</li>
              <li className="hover:text-sage-300 transition-colors cursor-pointer">Annual Maintenance</li>
              <li className="hover:text-sage-300 transition-colors cursor-pointer">Solar Thermal Panels</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white">Contact Us</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3 group cursor-pointer">
                <Phone className="h-5 w-5 text-sage-400 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform" />
                <div>
                  <p className="text-sm font-medium text-white">24/7 Emergency</p>
                  <a href="tel:07398873176" className="text-sm text-gray-300 hover:text-sage-300 transition-colors">
                    07398 873176
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3 group cursor-pointer">
                <Phone className="h-5 w-5 text-sage-400 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform" />
                <div>
                  <p className="text-sm font-medium text-white">Office</p>
                  <a href="tel:03337890987" className="text-sm text-gray-300 hover:text-sage-300 transition-colors">
                    0333 789 0987
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3 group cursor-pointer">
                <Mail className="h-5 w-5 text-sage-400 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform" />
                <div>
                  <a href="mailto:info@magiccplumbing.com" className="text-sm text-gray-300 hover:text-sage-300 transition-colors">
                    info@magiccplumbing.com
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-sage-400 mt-0.5 flex-shrink-0" />
                <div className="space-y-2">
                  <div>
                    <p className="text-sm font-semibold text-sage-400">Wimbledon Office</p>
                    <p className="text-xs text-gray-400">International Projects</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div className="flex space-x-4 mt-6">
              <a 
                href="https://www.instagram.com/magiccplumbing" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-sage-600 p-2 rounded-full transition-all hover:scale-110"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a 
                href="#" 
                className="bg-white/10 hover:bg-sage-600 p-2 rounded-full transition-all hover:scale-110"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href="#" 
                className="bg-white/10 hover:bg-sage-600 p-2 rounded-full transition-all hover:scale-110"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © 2024 Magic C Plumbing. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm text-gray-400">
              <a href="#" className="hover:text-sage-400 transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-sage-400 transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-sage-400 transition-colors">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
